import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noPriority: {
		id: 'issue-table-grouping.group-row.group-header.priority-group-header.no-priority',
		defaultMessage: 'No priority',
		description: 'Label for grouped items without priority',
	},
});
